function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
// locals
import Chord from './Chord';
export default observer(function StructuralVariantChords(_ref) {
  var features = _ref.features,
    config = _ref.config,
    displayModel = _ref.displayModel,
    blockDefinitions = _ref.blockDefinitions,
    radius = _ref.radius,
    bezierRadius = _ref.bezierRadius,
    selectedFeatureId = _ref.displayModel.selectedFeatureId,
    onChordClick = _ref.onChordClick;
  // make a map of refName -> blockDefinition
  var blocksForRefsMemo = useMemo(function () {
    var blocksForRefs = {};
    blockDefinitions.forEach(function (block) {
      ;
      (block.region.elided ? block.region.regions : [block.region]).forEach(function (r) {
        return blocksForRefs[r.refName] = block;
      });
    });
    return blocksForRefs;
  }, [blockDefinitions]);
  var chords = [];
  var _iterator = _createForOfIteratorHelper(features.values()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var feature = _step.value;
      var id = feature.id();
      var selected = String(selectedFeatureId) === String(id);
      chords.push(React.createElement(Chord, {
        key: id,
        feature: feature,
        config: config,
        radius: radius,
        bezierRadius: bezierRadius,
        blocksForRefs: blocksForRefsMemo,
        selected: selected,
        onClick: onChordClick
      }));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var trackStyleId = "chords-".concat(typeof jest !== 'undefined' ? 'test' : displayModel.id);
  return React.createElement("g", {
    id: trackStyleId,
    "data-testid": "structuralVariantChordRenderer"
  }, React.createElement("style", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: "\n          #".concat(trackStyleId, " > path {\n            cursor: crosshair;\n            fill: none;\n          }\n")
    }
  }), chords);
});